"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var assets_1 = require("../../../../../assets");
var style_1 = require("../../../../../style");
var react_2 = require("react");
var SIZE_MAP = {
    '3xs': 6,
    '2xs': 8,
    xs: 10,
    sm: 12,
    md: 14,
    lg: 16,
    xl: 18,
    '2xl': 20,
};
var AvatarCompanyIndicator = function (_a) {
    var company = _a.company, size = _a.size;
    var finalSize = typeof size === 'number' ? size : SIZE_MAP[size];
    var style = react_2.useMemo(function () { return react_1.css({
        width: finalSize,
        height: finalSize,
        border: finalSize / 9 + "px solid var(" + style_1.RootColor.White + ")",
        borderRadius: '50%',
        backgroundColor: "var(" + style_1.RootColor.Gray.LIGHT_2 + ")",
    }); }, [finalSize]);
    return (react_1.jsx("img", { src: assets_1.AvatarCompanyLogoAsset[company], css: style }));
};
exports.default = AvatarCompanyIndicator;
